<script lang="ts">
    import { onMount } from 'svelte'
    import type { WabaMetadataStatus } from '../../../modules/brokerApi/channels/dto/waba-metadata-status.dto'
    import Zbutton from '../../_common/z/zbutton.svelte'
    import Zframe from '../../_common/z/zframe.svelte'
    import type { ChannelCredentials } from '../../../modules/brokerApi/channels/channel'
    import type { GridButton } from '../../_common/z/zgrid'

    export let status: WabaMetadataStatus
    export let credentials: ChannelCredentials

    interface boxInterface {
        alert: 'success' | 'warning' | 'danger'
        title: string
        info: string
        status: string
        errors: { label: string; description: string; link: string }[]
        level: number
    }

    onMount(async () => {
        load()
    })

    let boxes: boxInterface[] = []
    function load() {
        boxes = []
        console.log('status', credentials, status)
        for (const item of status.health_status?.entities) {
            if (item.entity_type === 'APP') continue
            const t = translate(item.additional_info?.join(', ') || '')
            const box: boxInterface = {
                level: getLevel(item.entity_type),
                alert: getAlert(item.can_send_message),
                title: getTitle(item.entity_type),
                status: getStatus(item.can_send_message),
                info: t.message,
                errors: [],
            }
            if (item.errors) {
                for (const error of item.errors) {
                    const description = error.possible_solution || error.error_description || ''
                    if (description.includes('Configure SIP')) continue
                    const t = translate(description)
                    box.errors.push({
                        description: t.message,
                        label: box.alert === 'danger' ? 'Corrigir' : 'Ver',
                        link: t.link,
                    })
                }
            }
            boxes.push(box)
        }
        // ordering
        boxes = boxes.sort((a, b) => a.level - b.level)

        boxes = boxes
    }

    function openLink(link: string) {
        window.open(link, '_blank')
    }

    function getTitle(type) {
        if (type === 'BUSINESS') return 'Meta Business Suite'
        if (type === 'WABA') return 'Gerenciador do WhatsApp'
        if (type === 'PHONE_NUMBER') return 'Número de Telefone'
        return type
    }

    function getLevel(type) {
        if (type === 'BUSINESS') return 0
        if (type === 'WABA') return 1
        if (type === 'PHONE_NUMBER') return 2
        return 3
    }

    function getAlert(s: string) {
        if (s === 'LIMITED') return 'warning'
        if (s === 'BLOCKED') return 'danger'
        if (s === 'AVAILABLE') return 'success'
        return 'success'
    }

    function getStatus(s: string) {
        if (s === 'APPROVED') return 'aprovado'
        if (s === 'LIMITED') return 'limitado'
        if (s === 'BLOCKED') return 'bloqueado'
        if (s === 'AVAILABLE') return 'disponível'
        if (s === 'APPROVED') return 'aprovado'
        return s
    }

    let paymentLink: string =
        'https://business.facebook.com/billing_hub/accounts/details/?asset_id=' + credentials.wabaID + '&business_id=' + credentials.wabaBusinessID
    let verificationLink: string = 'https://business.facebook.com/latest/settings/security_center?business_id=' + credentials.wabaBusinessID
    let bmLink: string = 'https://business.facebook.com/latest/settings/business_info?business_id=' + credentials.wabaBusinessID
    let wabaLink: string =
        'https://business.facebook.com/latest/whatsapp_manager/overview?business_id=' + credentials.wabaBusinessID + '&asset_id=' + credentials.wabaID

    function translate(m: string): { message: string; link?: string } {
        if (m.includes('Your display name has not been approved yet')) {
            return {
                message:
                    'Seu nome de exibição ainda não foi aprovado pelo WhatsApp. Seu limite de mensagens enviadas será limitado até que ele seja aprovado. Essa aprovação é feita pelo WhatsApp automaticamente.',
                link: '',
            }
        }
        if (m.includes('start or resolve the business verification request')) {
            return {
                message: 'Acesse as configurações da empresa e inicie ou resolva a solicitação de verificação da empresa.',
                link: verificationLink,
            }
        }
        if (m.includes('Please add a new payment method')) {
            return {
                message: 'Ocorreu um erro com seu método de pagamento. Por favor, adicione um novo método de pagamento à conta.',
                link: paymentLink,
            }
        }
        return {
            message: m,
            link: bmLink,
        }
    }

    let acts: GridButton[] = []

    acts.push({
        label: 'Gerenciador do WhatsApp',
        callback: () => openLink(wabaLink),
    })

    acts.push({
        label: 'Pagamentos do WhatsApp',
        callback: () => openLink(paymentLink),
    })
</script>

<div class="root-waba-status">
    <Zframe title="Status de seu WhatsApp Business" class="m-2" {acts}>
        <div class="general-status -success-{status.health_status.can_send_message !== 'BLOCKED'}">
            <div class="-general-label">Status atual:</div>
            <div class="-general-value">
                {status.health_status.can_send_message !== 'BLOCKED' ? 'você pode enviar mensagens' : 'você não pode enviar mensagens'}
            </div>
        </div>
        {#each boxes as box}
            <div class="box alert-{box.alert}" style="margin-left:{box.level * 0}px;">
                <div class="-title">{box.title}</div>
                <div class="-status">Status: {box.status}</div>
                <div class="-info">{box.info}</div>
                <div class="-errors">
                    {#if box.errors?.length > 0}
                        <div class="-error-title">{box.alert === 'danger' ? 'Erros:' : 'Pontos de atenção:'}</div>
                        {#each box.errors as error}
                            <div class="-error">
                                <div class="-description">{error.description}</div>
                                <div class="-button">
                                    <Zbutton class="waba-error-button" label={error.label} on:click={() => openLink(error.link)}></Zbutton>
                                </div>
                            </div>
                        {/each}
                    {/if}
                </div>
            </div>
        {/each}
    </Zframe>
</div>

<style>
    .general-status {
        display: flex;
    }

    .general-status.-success-true .-general-value {
        color: #388e3c;
        padding-left: 4px;
        font-weight: bold;
    }
    .general-status.-success-false .-general-value {
        padding-left: 4px;
        color: #e53935;
        font-weight: bold;
    }

    .box {
        background-color: #88888825;
        margin-top: 11px;
        padding: 6px;
        border-radius: 6px;
    }

    .box .-info {
        font-size: 15px;
    }

    .box .-errors {
        margin-top: 4px;
        margin-left: 32px;
        margin-right: 32px;
    }
    .box .-error {
        display: flex;
        align-items: center;
        border-top: 1px solid #66666666;
        padding: 2px;
    }
    .box .-error .-description {
        flex-grow: 1;
        font-size: 15px;
    }

    .box .-title {
        font-weight: bold;

        font-size: 20px;
    }

    .box .-status {
        display: inline-block;
        border-radius: 4px;
    }

    .alert-success .-status {
        color: #388e3c;
    }

    .alert-warning .-status {
        color: #ff8f00;
    }

    .alert-danger .-status {
        color: #e53935;
        font-weight: bold;
    }

    :global(.waba-error-button) {
        height: 32px !important;
    }
</style>
